import { connect } from 'react-redux';
import DetailsRoundModal from '../../components/details/details_round_modal';
import { selectRoundDates } from '../../selectors';

const mapStateToProps = (state) => ({
  roundDates: selectRoundDates(state),
});

export default connect(mapStateToProps)(DetailsRoundModal);
